import React from 'react'
import { Order } from '../../assets'
import { t } from '../../miscellaneous/language'

const OrderPlacedStatus = ({updateStaticStatus}) => {
    return (
        <div className="after-order-card">
            <div className="after-order-status-container">
                <span className="after-order-title">{t.text.orderPlaced.title}</span>
                <span className="after-order-desc">{t.text.orderPlaced.desc}</span>
            </div>
            <div className="after-order-icon-container">
                <Order id="order-medium-icon" />
            </div>
        </div>
    )
}

export default OrderPlacedStatus
